import { render, staticRenderFns } from "./ChatList.vue?vue&type=template&id=31f21b52&scoped=true"
import script from "./ChatList.vue?vue&type=script&lang=js"
export * from "./ChatList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/chat.css?vue&type=style&index=0&id=31f21b52&prod&scoped=true&lang=css&external"
import style1 from "./ChatList.vue?vue&type=style&index=1&id=31f21b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f21b52",
  null
  
)

export default component.exports